import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { MojoShareResourceAutocompleteService, User as MojoUser } from 'mojo-share-resource';
import { combineLatest, Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { getSortedTeamMembersByLastModifiedDate } from '@collections/jobs';
import { TeamMembersListItem, User } from '@shared/models';
import { UserService } from '@shared/services';

@Injectable()
export class JobSharingAutocompleteService implements MojoShareResourceAutocompleteService {
  constructor(private userService: UserService, private store: Store<{}>) {}
  search(userName: string): Observable<MojoUser[]> {
    return combineLatest([this.userService.getFilteredUsers(userName), this.getCurrentTeamMembers()]).pipe(
      map(([filteredUsers, teamMemberList]) => this.filterOutAlreadyUsedUsers(filteredUsers, teamMemberList) as MojoUser[]),
    );
  }

  private filterOutAlreadyUsedUsers(filteredUsers: User[], teamMembersList: TeamMembersListItem[]): User[] {
    return filteredUsers.filter((user) => !teamMembersList.some((teamMember) => teamMember.user.id.toString() === user.id.toString()));
  }

  private getCurrentTeamMembers(): Observable<TeamMembersListItem[]> {
    return this.store.pipe(
      select(getSortedTeamMembersByLastModifiedDate),
      filter((teamMembers: TeamMembersListItem[]) => !teamMembers.some((teamMember) => !teamMember.user)),
    );
  }
}
